__turbopack_context__.v({
  "footerLink": "CheckoutFooter-module-scss-module__Yf1SWa__footerLink",
  "footerLinkItem": "CheckoutFooter-module-scss-module__Yf1SWa__footerLinkItem",
  "footerLinks": "CheckoutFooter-module-scss-module__Yf1SWa__footerLinks",
  "root": "CheckoutFooter-module-scss-module__Yf1SWa__root",
});
